/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { AccessLogResponse } from '../models';
// @ts-ignore
import { AdminAppsResponse } from '../models';
// @ts-ignore
import { AdminInviteRequest } from '../models';
// @ts-ignore
import { AdminInviteResponse } from '../models';
// @ts-ignore
import { AdminInviteSetupRequest } from '../models';
// @ts-ignore
import { AdminLoginRequest } from '../models';
// @ts-ignore
import { AdminLoginResponse } from '../models';
// @ts-ignore
import { AdminOtpRegisterRequest } from '../models';
// @ts-ignore
import { AdminOtpVerifyRequest } from '../models';
// @ts-ignore
import { AdminPasswordResetRequest } from '../models';
// @ts-ignore
import { AdminRegisterRequest } from '../models';
// @ts-ignore
import { AdminResponse } from '../models';
// @ts-ignore
import { AdminSignUpRequest } from '../models';
// @ts-ignore
import { AdminUpdateRequest } from '../models';
// @ts-ignore
import { AdminsListResponse } from '../models';
// @ts-ignore
import { AdminsPopulatedListResponse } from '../models';
// @ts-ignore
import { AuthorizedAdminResponse } from '../models';
// @ts-ignore
import { BulkAdminsRequest } from '../models';
// @ts-ignore
import { Resend2FAOtpResponse } from '../models';
// @ts-ignore
import { TermsAcceptanceResponse } from '../models';
// @ts-ignore
import { Verify2FAOtpRequest } from '../models';
// @ts-ignore
import { Verify2FAOtpResponse } from '../models';
/**
 * AdminsApi - axios parameter creator
 * @export
 */
export const AdminsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary accept invite
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAcceptInvite: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerAcceptInvite', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminsControllerAcceptInvite', 'id', id)
            const localVarPath = `/v2/admins/{id}/invite/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authorize Admin
         * @param {AdminsControllerAuthorizeAppTypeEnum} [appType] 
         * @param {string} [gamixAppId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAuthorize: async (appType?: AdminsControllerAuthorizeAppTypeEnum, gamixAppId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appType !== undefined) {
                localVarQueryParameter['appType'] = appType;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if admin has accepted Terms of Service
         * @param {string} email Admin email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCheckTermsAcceptance: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('adminsControllerCheckTermsAcceptance', 'email', email)
            const localVarPath = `/v2/admins/terms-acceptance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin sign-up
         * @param {string} gamixAppId 
         * @param {AdminSignUpRequest} adminSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreate: async (gamixAppId: string, adminSignUpRequest: AdminSignUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminSignUpRequest' is not null or undefined
            assertParamExists('adminsControllerCreate', 'adminSignUpRequest', adminSignUpRequest)
            const localVarPath = `/v2/admins/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSignUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This api sends a confirmation email to help verify the users identity
         * @param {AdminOtpRegisterRequest} adminOtpRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreateWithOtp: async (adminOtpRegisterRequest: AdminOtpRegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminOtpRegisterRequest' is not null or undefined
            assertParamExists('adminsControllerCreateWithOtp', 'adminOtpRegisterRequest', adminOtpRegisterRequest)
            const localVarPath = `/v2/admins/set-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOtpRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send reset password email for forget password
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerForgetPassword: async (adminPasswordResetRequest: AdminPasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPasswordResetRequest' is not null or undefined
            assertParamExists('adminsControllerForgetPassword', 'adminPasswordResetRequest', adminPasswordResetRequest)
            const localVarPath = `/v2/admins/forget-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admin access log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerGetAccessLog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/access-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication pending2FAToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Invite
         * @param {string} gamixAppId 
         * @param {AdminInviteRequest} adminInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerInvite: async (gamixAppId: string, adminInviteRequest: AdminInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerInvite', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminInviteRequest' is not null or undefined
            assertParamExists('adminsControllerInvite', 'adminInviteRequest', adminInviteRequest)
            const localVarPath = `/v2/admins/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list admins
         * @param {string} gamixAppId 
         * @param {Array<AdminsControllerListAppTypeEnum>} [appType] 
         * @param {AdminsControllerListRoleEnum} [role] 
         * @param {string} [email] 
         * @param {Array<AdminsControllerListTypeEnum>} [type] 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerList: async (gamixAppId: string, appType?: Array<AdminsControllerListAppTypeEnum>, role?: AdminsControllerListRoleEnum, email?: string, type?: Array<AdminsControllerListTypeEnum>, search?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appType) {
                localVarQueryParameter['appType'] = appType;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List bulk admins
         * @param {string} gamixAppId 
         * @param {BulkAdminsRequest} bulkAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerListBulk: async (gamixAppId: string, bulkAdminsRequest: BulkAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerListBulk', 'gamixAppId', gamixAppId)
            // verify required parameter 'bulkAdminsRequest' is not null or undefined
            assertParamExists('adminsControllerListBulk', 'bulkAdminsRequest', bulkAdminsRequest)
            const localVarPath = `/v2/admins/bulk-get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Login
         * @param {AdminLoginRequest} adminLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogin: async (adminLoginRequest: AdminLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminLoginRequest' is not null or undefined
            assertParamExists('adminsControllerLogin', 'adminLoginRequest', adminLoginRequest)
            const localVarPath = `/v2/admins/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This api logs out an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register new admin without apps
         * @param {AdminRegisterRequest} adminRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRegister: async (adminRegisterRequest: AdminRegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminRegisterRequest' is not null or undefined
            assertParamExists('adminsControllerRegister', 'adminRegisterRequest', adminRegisterRequest)
            const localVarPath = `/v2/admins/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend 2FA OTP code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResend2FACode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/resend2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication pending2FAToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send reset password email
         * @param {string} gamixAppId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResetPassword: async (gamixAppId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerResetPassword', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminPasswordResetRequest' is not null or undefined
            assertParamExists('adminsControllerResetPassword', 'adminPasswordResetRequest', adminPasswordResetRequest)
            const localVarPath = `/v2/admins/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary revoke an app from an admin
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRevoke: async (gamixAppId: string, adminId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerRevoke', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('adminsControllerRevoke', 'adminId', adminId)
            const localVarPath = `/v2/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (adminId !== undefined) {
                localVarQueryParameter['adminId'] = adminId;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Admin
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdate: async (adminUpdateRequest: AdminUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpdateRequest' is not null or undefined
            assertParamExists('adminsControllerUpdate', 'adminUpdateRequest', adminUpdateRequest)
            const localVarPath = `/v2/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Other Admins
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdateById: async (gamixAppId: string, id: string, adminUpdateRequest: AdminUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerUpdateById', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminsControllerUpdateById', 'id', id)
            // verify required parameter 'adminUpdateRequest' is not null or undefined
            assertParamExists('adminsControllerUpdateById', 'adminUpdateRequest', adminUpdateRequest)
            const localVarPath = `/v2/admins/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change password
         * @param {AdminInviteSetupRequest} adminInviteSetupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdatePassword: async (adminInviteSetupRequest: AdminInviteSetupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminInviteSetupRequest' is not null or undefined
            assertParamExists('adminsControllerUpdatePassword', 'adminInviteSetupRequest', adminInviteSetupRequest)
            const localVarPath = `/v2/admins/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInviteSetupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify new admin registration
         * @param {string} bin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerify: async (bin: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bin' is not null or undefined
            assertParamExists('adminsControllerVerify', 'bin', bin)
            const localVarPath = `/v2/admins/verify/{bin}`
                .replace(`{${"bin"}}`, encodeURIComponent(String(bin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify 2FA OTP
         * @param {Verify2FAOtpRequest} verify2FAOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminLoginOtp: async (verify2FAOtpRequest: Verify2FAOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verify2FAOtpRequest' is not null or undefined
            assertParamExists('adminsControllerVerifyAdminLoginOtp', 'verify2FAOtpRequest', verify2FAOtpRequest)
            const localVarPath = `/v2/admins/verify2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication pending2FAToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verify2FAOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify your email through the link sent to your mail to complete registration
         * @param {AdminOtpVerifyRequest} adminOtpVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminOtp: async (adminOtpVerifyRequest: AdminOtpVerifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminOtpVerifyRequest' is not null or undefined
            assertParamExists('adminsControllerVerifyAdminOtp', 'adminOtpVerifyRequest', adminOtpVerifyRequest)
            const localVarPath = `/v2/admins/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOtpVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminsApi - functional programming interface
 * @export
 */
export const AdminsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary accept invite
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerAcceptInvite(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerAcceptInvite(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerAcceptInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Authorize Admin
         * @param {AdminsControllerAuthorizeAppTypeEnum} [appType] 
         * @param {string} [gamixAppId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerAuthorize(appType?: AdminsControllerAuthorizeAppTypeEnum, gamixAppId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAppsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerAuthorize(appType, gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerAuthorize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if admin has accepted Terms of Service
         * @param {string} email Admin email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerCheckTermsAcceptance(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermsAcceptanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerCheckTermsAcceptance(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerCheckTermsAcceptance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin sign-up
         * @param {string} gamixAppId 
         * @param {AdminSignUpRequest} adminSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerCreate(gamixAppId: string, adminSignUpRequest: AdminSignUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerCreate(gamixAppId, adminSignUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This api sends a confirmation email to help verify the users identity
         * @param {AdminOtpRegisterRequest} adminOtpRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerCreateWithOtp(adminOtpRegisterRequest: AdminOtpRegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerCreateWithOtp(adminOtpRegisterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerCreateWithOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary send reset password email for forget password
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerForgetPassword(adminPasswordResetRequest: AdminPasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerForgetPassword(adminPasswordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerForgetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get admin access log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerGetAccessLog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerGetAccessLog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerGetAccessLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Invite
         * @param {string} gamixAppId 
         * @param {AdminInviteRequest} adminInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerInvite(gamixAppId: string, adminInviteRequest: AdminInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerInvite(gamixAppId, adminInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list admins
         * @param {string} gamixAppId 
         * @param {Array<AdminsControllerListAppTypeEnum>} [appType] 
         * @param {AdminsControllerListRoleEnum} [role] 
         * @param {string} [email] 
         * @param {Array<AdminsControllerListTypeEnum>} [type] 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerList(gamixAppId: string, appType?: Array<AdminsControllerListAppTypeEnum>, role?: AdminsControllerListRoleEnum, email?: string, type?: Array<AdminsControllerListTypeEnum>, search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsPopulatedListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerList(gamixAppId, appType, role, email, type, search, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List bulk admins
         * @param {string} gamixAppId 
         * @param {BulkAdminsRequest} bulkAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerListBulk(gamixAppId: string, bulkAdminsRequest: BulkAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerListBulk(gamixAppId, bulkAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerListBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Login
         * @param {AdminLoginRequest} adminLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerLogin(adminLoginRequest: AdminLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerLogin(adminLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This api logs out an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register new admin without apps
         * @param {AdminRegisterRequest} adminRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerRegister(adminRegisterRequest: AdminRegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerRegister(adminRegisterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend 2FA OTP code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerResend2FACode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resend2FAOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerResend2FACode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerResend2FACode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary send reset password email
         * @param {string} gamixAppId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerResetPassword(gamixAppId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerResetPassword(gamixAppId, adminPasswordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary revoke an app from an admin
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerRevoke(gamixAppId: string, adminId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerRevoke(gamixAppId, adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerRevoke']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Admin
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerUpdate(adminUpdateRequest: AdminUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerUpdate(adminUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Other Admins
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerUpdateById(gamixAppId: string, id: string, adminUpdateRequest: AdminUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerUpdateById(gamixAppId, id, adminUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerUpdateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change password
         * @param {AdminInviteSetupRequest} adminInviteSetupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerUpdatePassword(adminInviteSetupRequest: AdminInviteSetupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerUpdatePassword(adminInviteSetupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerUpdatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify new admin registration
         * @param {string} bin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerVerify(bin: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerVerify(bin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify 2FA OTP
         * @param {Verify2FAOtpRequest} verify2FAOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest: Verify2FAOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Verify2FAOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerVerifyAdminLoginOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify your email through the link sent to your mail to complete registration
         * @param {AdminOtpVerifyRequest} adminOtpVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerVerifyAdminOtp(adminOtpVerifyRequest: AdminOtpVerifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerVerifyAdminOtp(adminOtpVerifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerVerifyAdminOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminsApi - factory interface
 * @export
 */
export const AdminsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminsApiFp(configuration)
    return {
        /**
         * 
         * @summary accept invite
         * @param {AdminsApiAdminsControllerAcceptInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAcceptInvite(requestParameters: AdminsApiAdminsControllerAcceptInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminsControllerAcceptInvite(requestParameters.gamixAppId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authorize Admin
         * @param {AdminsApiAdminsControllerAuthorizeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAuthorize(requestParameters: AdminsApiAdminsControllerAuthorizeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAppsResponse> {
            return localVarFp.adminsControllerAuthorize(requestParameters.appType, requestParameters.gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if admin has accepted Terms of Service
         * @param {AdminsApiAdminsControllerCheckTermsAcceptanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCheckTermsAcceptance(requestParameters: AdminsApiAdminsControllerCheckTermsAcceptanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<TermsAcceptanceResponse> {
            return localVarFp.adminsControllerCheckTermsAcceptance(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin sign-up
         * @param {AdminsApiAdminsControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreate(requestParameters: AdminsApiAdminsControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerCreate(requestParameters.gamixAppId, requestParameters.adminSignUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This api sends a confirmation email to help verify the users identity
         * @param {AdminsApiAdminsControllerCreateWithOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreateWithOtp(requestParameters: AdminsApiAdminsControllerCreateWithOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminsControllerCreateWithOtp(requestParameters.adminOtpRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send reset password email for forget password
         * @param {AdminsApiAdminsControllerForgetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerForgetPassword(requestParameters: AdminsApiAdminsControllerForgetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminsControllerForgetPassword(requestParameters.adminPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admin access log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerGetAccessLog(options?: RawAxiosRequestConfig): AxiosPromise<AccessLogResponse> {
            return localVarFp.adminsControllerGetAccessLog(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Invite
         * @param {AdminsApiAdminsControllerInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerInvite(requestParameters: AdminsApiAdminsControllerInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInviteResponse> {
            return localVarFp.adminsControllerInvite(requestParameters.gamixAppId, requestParameters.adminInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list admins
         * @param {AdminsApiAdminsControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerList(requestParameters: AdminsApiAdminsControllerListRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminsPopulatedListResponse> {
            return localVarFp.adminsControllerList(requestParameters.gamixAppId, requestParameters.appType, requestParameters.role, requestParameters.email, requestParameters.type, requestParameters.search, requestParameters.limit, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List bulk admins
         * @param {AdminsApiAdminsControllerListBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerListBulk(requestParameters: AdminsApiAdminsControllerListBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminsListResponse> {
            return localVarFp.adminsControllerListBulk(requestParameters.gamixAppId, requestParameters.bulkAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Login
         * @param {AdminsApiAdminsControllerLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogin(requestParameters: AdminsApiAdminsControllerLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminLoginResponse> {
            return localVarFp.adminsControllerLogin(requestParameters.adminLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This api logs out an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminsControllerLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register new admin without apps
         * @param {AdminsApiAdminsControllerRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRegister(requestParameters: AdminsApiAdminsControllerRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResponse> {
            return localVarFp.adminsControllerRegister(requestParameters.adminRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend 2FA OTP code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResend2FACode(options?: RawAxiosRequestConfig): AxiosPromise<Resend2FAOtpResponse> {
            return localVarFp.adminsControllerResend2FACode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send reset password email
         * @param {AdminsApiAdminsControllerResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResetPassword(requestParameters: AdminsApiAdminsControllerResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminsControllerResetPassword(requestParameters.gamixAppId, requestParameters.adminPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary revoke an app from an admin
         * @param {AdminsApiAdminsControllerRevokeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRevoke(requestParameters: AdminsApiAdminsControllerRevokeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminsControllerRevoke(requestParameters.gamixAppId, requestParameters.adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Admin
         * @param {AdminsApiAdminsControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdate(requestParameters: AdminsApiAdminsControllerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerUpdate(requestParameters.adminUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Other Admins
         * @param {AdminsApiAdminsControllerUpdateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdateById(requestParameters: AdminsApiAdminsControllerUpdateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerUpdateById(requestParameters.gamixAppId, requestParameters.id, requestParameters.adminUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change password
         * @param {AdminsApiAdminsControllerUpdatePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdatePassword(requestParameters: AdminsApiAdminsControllerUpdatePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResponse> {
            return localVarFp.adminsControllerUpdatePassword(requestParameters.adminInviteSetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify new admin registration
         * @param {AdminsApiAdminsControllerVerifyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerify(requestParameters: AdminsApiAdminsControllerVerifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerVerify(requestParameters.bin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify 2FA OTP
         * @param {AdminsApiAdminsControllerVerifyAdminLoginOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminLoginOtp(requestParameters: AdminsApiAdminsControllerVerifyAdminLoginOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Verify2FAOtpResponse> {
            return localVarFp.adminsControllerVerifyAdminLoginOtp(requestParameters.verify2FAOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify your email through the link sent to your mail to complete registration
         * @param {AdminsApiAdminsControllerVerifyAdminOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminOtp(requestParameters: AdminsApiAdminsControllerVerifyAdminOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerVerifyAdminOtp(requestParameters.adminOtpVerifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminsControllerAcceptInvite operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerAcceptInviteRequest
 */
export interface AdminsApiAdminsControllerAcceptInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerAcceptInvite
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerAcceptInvite
     */
    readonly id: string
}

/**
 * Request parameters for adminsControllerAuthorize operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerAuthorizeRequest
 */
export interface AdminsApiAdminsControllerAuthorizeRequest {
    /**
     * 
     * @type {'coreLoyalty' | 'coreTeams' | 'corePilot' | 'POS' | 'fisico' | 'games' | 'advertiser' | 'retailer'}
     * @memberof AdminsApiAdminsControllerAuthorize
     */
    readonly appType?: AdminsControllerAuthorizeAppTypeEnum

    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerAuthorize
     */
    readonly gamixAppId?: string
}

/**
 * Request parameters for adminsControllerCheckTermsAcceptance operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerCheckTermsAcceptanceRequest
 */
export interface AdminsApiAdminsControllerCheckTermsAcceptanceRequest {
    /**
     * Admin email address
     * @type {string}
     * @memberof AdminsApiAdminsControllerCheckTermsAcceptance
     */
    readonly email: string
}

/**
 * Request parameters for adminsControllerCreate operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerCreateRequest
 */
export interface AdminsApiAdminsControllerCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerCreate
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {AdminSignUpRequest}
     * @memberof AdminsApiAdminsControllerCreate
     */
    readonly adminSignUpRequest: AdminSignUpRequest
}

/**
 * Request parameters for adminsControllerCreateWithOtp operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerCreateWithOtpRequest
 */
export interface AdminsApiAdminsControllerCreateWithOtpRequest {
    /**
     * 
     * @type {AdminOtpRegisterRequest}
     * @memberof AdminsApiAdminsControllerCreateWithOtp
     */
    readonly adminOtpRegisterRequest: AdminOtpRegisterRequest
}

/**
 * Request parameters for adminsControllerForgetPassword operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerForgetPasswordRequest
 */
export interface AdminsApiAdminsControllerForgetPasswordRequest {
    /**
     * 
     * @type {AdminPasswordResetRequest}
     * @memberof AdminsApiAdminsControllerForgetPassword
     */
    readonly adminPasswordResetRequest: AdminPasswordResetRequest
}

/**
 * Request parameters for adminsControllerInvite operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerInviteRequest
 */
export interface AdminsApiAdminsControllerInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerInvite
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {AdminInviteRequest}
     * @memberof AdminsApiAdminsControllerInvite
     */
    readonly adminInviteRequest: AdminInviteRequest
}

/**
 * Request parameters for adminsControllerList operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerListRequest
 */
export interface AdminsApiAdminsControllerListRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {Array<'coreLoyalty' | 'coreTeams' | 'corePilot' | 'POS' | 'fisico' | 'games' | 'advertiser' | 'retailer'>}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly appType?: Array<AdminsControllerListAppTypeEnum>

    /**
     * 
     * @type {'pos.salesRep' | 'pos.salesAdmin'}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly role?: AdminsControllerListRoleEnum

    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly email?: string

    /**
     * 
     * @type {Array<'internalLogin' | 'normal' | 'serviceAccount' | 'group'>}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly type?: Array<AdminsControllerListTypeEnum>

    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof AdminsApiAdminsControllerList
     */
    readonly skip?: number
}

/**
 * Request parameters for adminsControllerListBulk operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerListBulkRequest
 */
export interface AdminsApiAdminsControllerListBulkRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerListBulk
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {BulkAdminsRequest}
     * @memberof AdminsApiAdminsControllerListBulk
     */
    readonly bulkAdminsRequest: BulkAdminsRequest
}

/**
 * Request parameters for adminsControllerLogin operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerLoginRequest
 */
export interface AdminsApiAdminsControllerLoginRequest {
    /**
     * 
     * @type {AdminLoginRequest}
     * @memberof AdminsApiAdminsControllerLogin
     */
    readonly adminLoginRequest: AdminLoginRequest
}

/**
 * Request parameters for adminsControllerRegister operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerRegisterRequest
 */
export interface AdminsApiAdminsControllerRegisterRequest {
    /**
     * 
     * @type {AdminRegisterRequest}
     * @memberof AdminsApiAdminsControllerRegister
     */
    readonly adminRegisterRequest: AdminRegisterRequest
}

/**
 * Request parameters for adminsControllerResetPassword operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerResetPasswordRequest
 */
export interface AdminsApiAdminsControllerResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerResetPassword
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {AdminPasswordResetRequest}
     * @memberof AdminsApiAdminsControllerResetPassword
     */
    readonly adminPasswordResetRequest: AdminPasswordResetRequest
}

/**
 * Request parameters for adminsControllerRevoke operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerRevokeRequest
 */
export interface AdminsApiAdminsControllerRevokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerRevoke
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerRevoke
     */
    readonly adminId: string
}

/**
 * Request parameters for adminsControllerUpdate operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerUpdateRequest
 */
export interface AdminsApiAdminsControllerUpdateRequest {
    /**
     * 
     * @type {AdminUpdateRequest}
     * @memberof AdminsApiAdminsControllerUpdate
     */
    readonly adminUpdateRequest: AdminUpdateRequest
}

/**
 * Request parameters for adminsControllerUpdateById operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerUpdateByIdRequest
 */
export interface AdminsApiAdminsControllerUpdateByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerUpdateById
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerUpdateById
     */
    readonly id: string

    /**
     * 
     * @type {AdminUpdateRequest}
     * @memberof AdminsApiAdminsControllerUpdateById
     */
    readonly adminUpdateRequest: AdminUpdateRequest
}

/**
 * Request parameters for adminsControllerUpdatePassword operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerUpdatePasswordRequest
 */
export interface AdminsApiAdminsControllerUpdatePasswordRequest {
    /**
     * 
     * @type {AdminInviteSetupRequest}
     * @memberof AdminsApiAdminsControllerUpdatePassword
     */
    readonly adminInviteSetupRequest: AdminInviteSetupRequest
}

/**
 * Request parameters for adminsControllerVerify operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerVerifyRequest
 */
export interface AdminsApiAdminsControllerVerifyRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminsApiAdminsControllerVerify
     */
    readonly bin: string
}

/**
 * Request parameters for adminsControllerVerifyAdminLoginOtp operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerVerifyAdminLoginOtpRequest
 */
export interface AdminsApiAdminsControllerVerifyAdminLoginOtpRequest {
    /**
     * 
     * @type {Verify2FAOtpRequest}
     * @memberof AdminsApiAdminsControllerVerifyAdminLoginOtp
     */
    readonly verify2FAOtpRequest: Verify2FAOtpRequest
}

/**
 * Request parameters for adminsControllerVerifyAdminOtp operation in AdminsApi.
 * @export
 * @interface AdminsApiAdminsControllerVerifyAdminOtpRequest
 */
export interface AdminsApiAdminsControllerVerifyAdminOtpRequest {
    /**
     * 
     * @type {AdminOtpVerifyRequest}
     * @memberof AdminsApiAdminsControllerVerifyAdminOtp
     */
    readonly adminOtpVerifyRequest: AdminOtpVerifyRequest
}

/**
 * AdminsApi - object-oriented interface
 * @export
 * @class AdminsApi
 * @extends {BaseAPI}
 */
export class AdminsApi extends BaseAPI {
    /**
     * 
     * @summary accept invite
     * @param {AdminsApiAdminsControllerAcceptInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerAcceptInvite(requestParameters: AdminsApiAdminsControllerAcceptInviteRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerAcceptInvite(requestParameters.gamixAppId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authorize Admin
     * @param {AdminsApiAdminsControllerAuthorizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerAuthorize(requestParameters: AdminsApiAdminsControllerAuthorizeRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerAuthorize(requestParameters.appType, requestParameters.gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if admin has accepted Terms of Service
     * @param {AdminsApiAdminsControllerCheckTermsAcceptanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerCheckTermsAcceptance(requestParameters: AdminsApiAdminsControllerCheckTermsAcceptanceRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerCheckTermsAcceptance(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin sign-up
     * @param {AdminsApiAdminsControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerCreate(requestParameters: AdminsApiAdminsControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerCreate(requestParameters.gamixAppId, requestParameters.adminSignUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This api sends a confirmation email to help verify the users identity
     * @param {AdminsApiAdminsControllerCreateWithOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerCreateWithOtp(requestParameters: AdminsApiAdminsControllerCreateWithOtpRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerCreateWithOtp(requestParameters.adminOtpRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send reset password email for forget password
     * @param {AdminsApiAdminsControllerForgetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerForgetPassword(requestParameters: AdminsApiAdminsControllerForgetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerForgetPassword(requestParameters.adminPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admin access log
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerGetAccessLog(options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerGetAccessLog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Invite
     * @param {AdminsApiAdminsControllerInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerInvite(requestParameters: AdminsApiAdminsControllerInviteRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerInvite(requestParameters.gamixAppId, requestParameters.adminInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list admins
     * @param {AdminsApiAdminsControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerList(requestParameters: AdminsApiAdminsControllerListRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerList(requestParameters.gamixAppId, requestParameters.appType, requestParameters.role, requestParameters.email, requestParameters.type, requestParameters.search, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List bulk admins
     * @param {AdminsApiAdminsControllerListBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerListBulk(requestParameters: AdminsApiAdminsControllerListBulkRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerListBulk(requestParameters.gamixAppId, requestParameters.bulkAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Login
     * @param {AdminsApiAdminsControllerLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerLogin(requestParameters: AdminsApiAdminsControllerLoginRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerLogin(requestParameters.adminLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This api logs out an admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerLogout(options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register new admin without apps
     * @param {AdminsApiAdminsControllerRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerRegister(requestParameters: AdminsApiAdminsControllerRegisterRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerRegister(requestParameters.adminRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend 2FA OTP code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerResend2FACode(options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerResend2FACode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send reset password email
     * @param {AdminsApiAdminsControllerResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerResetPassword(requestParameters: AdminsApiAdminsControllerResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerResetPassword(requestParameters.gamixAppId, requestParameters.adminPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary revoke an app from an admin
     * @param {AdminsApiAdminsControllerRevokeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerRevoke(requestParameters: AdminsApiAdminsControllerRevokeRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerRevoke(requestParameters.gamixAppId, requestParameters.adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Admin
     * @param {AdminsApiAdminsControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerUpdate(requestParameters: AdminsApiAdminsControllerUpdateRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerUpdate(requestParameters.adminUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Other Admins
     * @param {AdminsApiAdminsControllerUpdateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerUpdateById(requestParameters: AdminsApiAdminsControllerUpdateByIdRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerUpdateById(requestParameters.gamixAppId, requestParameters.id, requestParameters.adminUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change password
     * @param {AdminsApiAdminsControllerUpdatePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerUpdatePassword(requestParameters: AdminsApiAdminsControllerUpdatePasswordRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerUpdatePassword(requestParameters.adminInviteSetupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify new admin registration
     * @param {AdminsApiAdminsControllerVerifyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerVerify(requestParameters: AdminsApiAdminsControllerVerifyRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerVerify(requestParameters.bin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify 2FA OTP
     * @param {AdminsApiAdminsControllerVerifyAdminLoginOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerVerifyAdminLoginOtp(requestParameters: AdminsApiAdminsControllerVerifyAdminLoginOtpRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerVerifyAdminLoginOtp(requestParameters.verify2FAOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify your email through the link sent to your mail to complete registration
     * @param {AdminsApiAdminsControllerVerifyAdminOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerVerifyAdminOtp(requestParameters: AdminsApiAdminsControllerVerifyAdminOtpRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerVerifyAdminOtp(requestParameters.adminOtpVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminsControllerAuthorizeAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    CorePilot: 'corePilot',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;
export type AdminsControllerAuthorizeAppTypeEnum = typeof AdminsControllerAuthorizeAppTypeEnum[keyof typeof AdminsControllerAuthorizeAppTypeEnum];
/**
 * @export
 */
export const AdminsControllerListAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    CorePilot: 'corePilot',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;
export type AdminsControllerListAppTypeEnum = typeof AdminsControllerListAppTypeEnum[keyof typeof AdminsControllerListAppTypeEnum];
/**
 * @export
 */
export const AdminsControllerListRoleEnum = {
    SalesRep: 'pos.salesRep',
    SalesAdmin: 'pos.salesAdmin'
} as const;
export type AdminsControllerListRoleEnum = typeof AdminsControllerListRoleEnum[keyof typeof AdminsControllerListRoleEnum];
/**
 * @export
 */
export const AdminsControllerListTypeEnum = {
    InternalLogin: 'internalLogin',
    Normal: 'normal',
    ServiceAccount: 'serviceAccount',
    Group: 'group'
} as const;
export type AdminsControllerListTypeEnum = typeof AdminsControllerListTypeEnum[keyof typeof AdminsControllerListTypeEnum];
